module.exports = __webpack_public_path__ + "img/arrow-left.35c4ad2b.svg";